import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { useLang } from "@/lib/LanguageContext";
import { fetchBlogList, formatBlogDate, BLOG_COPY } from "@/lib/blogApi";
import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";
import ImageHero from "@/components/ImageHero";

const BlogCard = ({ a, lang, read }) => (
  <Link to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`} className="group block border-t border-stone-200 pt-8">
    {a.hero_image_url && (
      <div className="overflow-hidden bg-stone-200 aspect-[4/3] mb-6">
        <img src={a.hero_image_url} alt={a.hero_image_alt || a.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
      </div>
    )}
    <p className="eyebrow text-stone-400">{formatBlogDate(a.published_at, lang)}</p>
    <h2 className="font-serif mt-3 text-2xl text-stone-900 leading-snug">{a.title}</h2>
    {a.meta_description && <p className="mt-3 text-stone-600 leading-relaxed text-sm">{a.meta_description}</p>}
    <span className="mt-5 inline-flex items-center gap-2 text-sm text-stone-800 border-b border-stone-300 group-hover:border-stone-900 pb-1 transition-colors">
      {read} <ArrowRight size={13} />
    </span>
  </Link>
);

export default function BlogHub() {
  const { lang } = useLang();
  const c = BLOG_COPY[lang];
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    fetchBlogList().then(setArticles).catch(() => setArticles([]));
  }, []);

  return (
    <PageShell>
      <Seo title={c.seoTitle} description={c.seoDesc} />
      <ImageHero testId="blog-hero" image="cafeLaptop" eyebrow={c.eyebrow} titleA={c.title} text={c.intro} />

      <section data-testid="blog-grid" className="py-14 sm:py-28 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          {articles === null && <p data-testid="blog-loading" className="text-stone-400 text-sm">{c.loading}…</p>}
          {articles && articles.length === 0 && <p data-testid="blog-empty" className="text-stone-500">{c.empty}</p>}
          {articles && articles.length > 0 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
              {articles.map((a) => <BlogCard key={a.slug} a={a} lang={lang} read={c.read} />)}
            </div>
          )}
        </div>
      </section>
    </PageShell>
  );
}
